import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const p=t("honduras",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                fill="white" />
            <path
                d="M0 4.5L24 4.5V9.83333L0 9.83333L0 4.5ZM0 15.1667L24 15.1667L24 20.5L0 20.5L0 15.1667Z"
                fill="#00BCE4" />
            <path
                d="M8.66654 10.2773L8.51654 10.8907H8.0332L8.4232 11.2729L8.2732 11.8862L8.66654 11.504L9.05987 11.8862L8.90987 11.2729L9.29987 10.8907H8.81654L8.66654 10.2773Z"
                fill="#00BCE4" />
            <path
                d="M8.81654 13.5577L8.66654 12.9443L8.51654 13.5577H8.0332L8.4232 13.9399L8.2732 14.5532L8.66654 14.171L9.05987 14.5532L8.90987 13.9399L9.29987 13.5577H8.81654Z"
                fill="#00BCE4" />
            <path
                d="M12.1505 12.2237L12.0005 11.6104L11.8505 12.2237H11.3672L11.7572 12.6059L11.6072 13.2192L12.0005 12.837L12.3939 13.2192L12.2439 12.6059L12.6339 12.2237H12.1505Z"
                fill="#00BCE4" />
            <path
                d="M15.0892 11.2729L14.9392 11.8862L15.3326 11.504L15.7259 11.8862L15.5759 11.2729L15.9659 10.8907H15.4826L15.3326 10.2773L15.1826 10.8907H14.6992L15.0892 11.2729Z"
                fill="#00BCE4" />
            <path
                d="M15.4826 13.5577L15.3326 12.9443L15.1826 13.5577H14.6992L15.0892 13.9399L14.9392 14.5532L15.3326 14.171L15.7259 14.5532L15.5759 13.9399L15.9659 13.5577H15.4826Z"
                fill="#00BCE4" />
        </svg>
    `),a=t("honduras_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_66579)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M-12 0.5L36 0.5L36 24.5L-12 24.5L-12 0.5Z"
                    fill="white" />
                <path
                    d="M-12 0.5L36 0.5V8.5L-12 8.5L-12 0.5ZM-12 16.5L36 16.5L36 24.5L-12 24.5L-12 16.5Z"
                    fill="#00BCE4" />
                <path
                    d="M5.33307 9.16602L5.03307 10.086H4.06641L4.84641 10.6593L4.54641 11.5793L5.33307 11.006L6.11974 11.5793L5.81974 10.6593L6.59974 10.086H5.63307L5.33307 9.16602Z"
                    fill="#00BCE4" />
                <path
                    d="M5.63307 14.086L5.33307 13.166L5.03307 14.086H4.06641L4.84641 14.6593L4.54641 15.5793L5.33307 15.006L6.11974 15.5793L5.81974 14.6593L6.59974 14.086H5.63307Z"
                    fill="#00BCE4" />
                <path
                    d="M12.301 12.086L12.001 11.166L11.701 12.086H10.7344L11.5144 12.6593L11.2144 13.5793L12.001 13.006L12.7877 13.5793L12.4877 12.6593L13.2677 12.086H12.301Z"
                    fill="#00BCE4" />
                <path
                    d="M18.1784 10.6593L17.8784 11.5793L18.6651 11.006L19.4518 11.5793L19.1518 10.6593L19.9318 10.086H18.9651L18.6651 9.16602L18.3651 10.086H17.3984L18.1784 10.6593Z"
                    fill="#00BCE4" />
                <path
                    d="M18.9651 14.086L18.6651 13.166L18.3651 14.086H17.3984L18.1784 14.6593L17.8784 15.5793L18.6651 15.006L19.4518 15.5793L19.1518 14.6593L19.9318 14.086H18.9651Z"
                    fill="#00BCE4" />
            </g>
            <defs>
                <clipPath id="clip0_19470_66579">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as Honduras,a as HondurasRounded};
